import script from "./RequestItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestItem.vue?vue&type=script&setup=true&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=578830f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-578830f4"]])

export default __exports__